module.exports = __webpack_public_path__ + "img/img_left_nav_recommend_hover.0436e7f4.svg";